import { mergeAttributes } from '@tiptap/core';
import Mention from '@tiptap/extension-mention';
import { createSuggestionMenu, type SuggestionMenuItem } from './suggestionMenu';

export type MentionedEntityType = 'character' | 'location' | 'plot';

export interface EntityMentionItem extends SuggestionMenuItem {
   label: string;
   entityType: MentionedEntityType;
}

const EntityMention = Mention.extend({
   addAttributes() {
      return {
         ...this.parent?.(),
         entityType: {
            default: null,
            parseHTML: (element) => element.getAttribute('data-entity-type'),
            renderHTML: (attributes) =>
               attributes.entityType ? { 'data-entity-type': attributes.entityType } : {},
         },
      };
   },
});

export const createEntityMentionExtension = (getItems: () => EntityMentionItem[]) =>
   EntityMention.configure({
      deleteTriggerWithBackspace: true,
      HTMLAttributes: {
         class: 'entity-mention',
         role: 'link',
      },
      renderText: ({ node }) => `@${node.attrs.label || node.attrs.id}`,
      renderHTML: ({ node, options }) => [
         'span',
         mergeAttributes(options.HTMLAttributes, {
            'data-entity-type': node.attrs.entityType,
            title: `Open ${node.attrs.entityType || 'entity'}`,
         }),
         `@${node.attrs.label || node.attrs.id}`,
      ],
      suggestion: {
         char: '@',
         allowSpaces: true,
         items: ({ query }) => {
            const normalizedQuery = query.trim().toLowerCase();
            return getItems()
               .filter((item) =>
                  `${item.label} ${item.entityType}`.toLowerCase().includes(normalizedQuery),
               )
               .slice(0, 12);
         },
         render: createSuggestionMenu<EntityMentionItem>,
      },
   });
